import createModel, { prop } from './lib/create_model';

const AgentPreferences = createModel({
  modelName: 'AgentPreferences',

  properties: {
    answerPanelLastOpenedAt: prop(String),
    answerSearchLanguage: prop(String),
  },

  setAnswerPanelLastOpenedAt(lastOpenedAt) {
    this.answerPanelLastOpenedAt = lastOpenedAt;
  },

  setAnswerSearchLanguage(language) {
    this.answerSearchLanguage = language;
  },
});

export default AgentPreferences;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/agent_preferences.js